export const CONTACT = {
  company: "Forage Animal Health & Nutrition Pvt Ltd",
  tagline: "Innovating Animal Health Through Science and Quality",
  phone: "+91 7060030899",
  phoneTel: "+917060030899", // for tel: links (E.164)
  whatsapp: "917060030899", // for wa.me link (no +)
  email: "sales@forageanimalhealth.com",
  enquiriesEmail: "enquiries@forageanimalhealth.com",
  address: {
    line1: "D-10 B, Industrial Estate, Delhi Road",
    line2: "Saharanpur",
    state: "Uttar Pradesh",
    pincode: "247001",
    country: "India",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=Forage+Animal+Health+%26+Nutrition+Pvt+Ltd%2C+D-10+B%2C+Industrial+Estate%2C+Delhi+Road%2C+Saharanpur+247001%2C+Uttar+Pradesh%2C+India&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Forage+Animal+Health+%26+Nutrition+Pvt+Ltd%2C+D-10+B%2C+Industrial+Estate%2C+Delhi+Road%2C+Saharanpur+247001%2C+Uttar+Pradesh%2C+India",
  // Default social links (overridden by admin Settings if populated)
  social: {
    linkedin: "",
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/manufacturing", label: "Manufacturing" },
  { to: "/quality", label: "Quality" },
  { to: "/contract-manufacturing", label: "Contract Mfg" },
  { to: "/certifications", label: "Certifications" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];
